
<div class="setting" *ngIf="userService.isAdmin || userService.isAM || userService.isTrader">
    <div class="setting-title">Connect or edit data sources</div>
    <div class="setting-subtitle">
    To add a new data source, you need to allow authentication for Rubii to access your account. Once connected, you
    can edit to select which data you would like to import and start tracking your campaign's performance.
    </div>
    <app-datasource></app-datasource>
</div>